export enum PreAccountingRoute {
  empty = '',
  transactions = 'transactions',
  purchases = 'purchases',
  labels = 'labels',
  clients = 'clients',
  sales = 'sales',
  endOfMission = 'end-of-mission'
}
